/**
 * @file: applyFacadeItemResult.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { InspectionSiteInfo } from '@euler/model';
import { SiteInspectionItemStaged } from '@euler/model/task-detail';
import { getFacadeItemResult } from './getFacadeItemResult';

/**
 * Puts on a staged facade check item the result derived from its photos, and
 * hands the result back for whatever else the caller keeps in sync with it.
 *
 * Call it whenever the photos of the item change - one taken, edited or
 * deleted - since the result follows them.
 */
export const applyFacadeItemResult = (
  item: SiteInspectionItemStaged,
  site: InspectionSiteInfo,
) => {
  const result = getFacadeItemResult(site, item.medias);
  const { abnormalLevel, severityLevel, option } = result;

  if (item.abnormalLevel !== abnormalLevel) {
    item.abnormalLevel = abnormalLevel;
  }

  if (item.severityLevel !== severityLevel) {
    item.severityLevel = severityLevel;
  }

  if (item.type === 'item') {
    if (item.optionLabel != option?.label) {
      item.optionLabel = option?.label;
    }
    if (item.optionLabelFormat != option?.labelFormat) {
      item.optionLabelFormat = option?.labelFormat;
    }
    if (item.maintenanceAdvice != option?.maintenanceAdvice) {
      item.maintenanceAdvice = option?.maintenanceAdvice;
    }
  }

  return result;
};
